import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Suppliers from "@/pages/Suppliers";
import Customers from "@/pages/Customers";
import FlowerTypes from "@/pages/FlowerTypes";
import Products from "@/pages/Products";
import Promotions from "@/pages/Promotions";
import Services from "@/pages/Services";
import Kardex from "@/pages/Kardex";
import Invoices from "@/pages/Invoices";
import CreditNotes from "@/pages/CreditNotes";
import Retentions from "@/pages/Retentions";
import RemissionGuides from "@/pages/RemissionGuides";
import Reports from "@/pages/Reports";
import Pos from "@/pages/Pos";
import SriDiagnostics from "@/pages/SriDiagnostics";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Landing />} />
            <Route path="/inicio" element={<Landing />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="customers" element={<Customers />} />
              <Route path="flower-types" element={<FlowerTypes />} />
              <Route path="products" element={<Products />} />
              <Route path="promotions" element={<Promotions />} />
              <Route path="services" element={<Services />} />
              <Route path="kardex" element={<Kardex />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="credit-notes" element={<CreditNotes />} />
              <Route path="retentions" element={<Retentions />} />
              <Route path="remission-guides" element={<RemissionGuides />} />
              <Route path="reports" element={<Reports />} />
              <Route path="pos" element={<Pos />} />
              <Route path="sri-diagnostics" element={<ProtectedRoute roles={["admin"]}><SriDiagnostics /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
              <Route
                path="settings"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <Settings />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
